import StyledLink from '../StyledLink'
import {
  MONITOR,
  RESULTS
} from '../routes'
import { PROP_TASK_INSTANCE_ID } from '../constants'
import type { Props } from '../types'

const base = '/' + MONITOR + '/' + RESULTS

interface Params {
  [PROP_TASK_INSTANCE_ID]: string
}

const LinkToMonitorRunResults = ({
  children,
  [PROP_TASK_INSTANCE_ID]: taskInstanceId,
  isHyperlink
}: Props & Params) =>
  <StyledLink
    isHyperlink={isHyperlink}
    to={base + '/runs/' + taskInstanceId}
  >
    {children}
  </StyledLink>

export default LinkToMonitorRunResults
